import axios from 'axios';

// Inject context into the request function so that it can access store etc.
export default (context, inject) => {
    const api = axios.create({
        baseURL: process.env.API_URL,
        timeout: process.server ? 5000 : 30000, // 5 seconds for server, 30 seconds for client
    });

    inject('folioApiRequest', function (schema, data, options) {
        let form;

        // Default options
        options = {
            authenticate: true,
            ...options,
        };

        if (!process.server && data instanceof FormData) {
            form = data;
            data = null;
        }

        if (!form) {
            if (process.server) {
                form = new require('form-data')();
            } else {
                form = new FormData();
            }
        }
        
        form.append('schema', schema);

        if (data) {
            for (let [key, value] of Object.entries(data)) {
                form.append(key, value);
            }
        }

        if (options.authenticate && context.store.getters['auth/isLoggedIn']) {
            form.append('token', context.store.getters['auth/getUser'].token);
            form.append('userId', context.store.getters['auth/getUser'].id);
        }

        if (process.server) {
            return axios.post(process.env.API_URL, form, {
                headers: form.getHeaders(),
            });
        }

        return api.post('', form);
    });
}